import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieConsentService } from '@app/core/services/cookie-consent.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="showBanner" class="fixed bottom-0 left-0 right-0 z-50 bg-gray-900 text-white shadow-lg">
      <div class="container mx-auto px-4 py-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div class="text-sm text-gray-200">
          Wir nutzen Matomo, um die Nutzung unserer Website zu analysieren und zu verbessern. Das Tracking erfolgt nur nach Ihrer Zustimmung.
          <a [href]="privacyUrl" target="_blank" class="underline text-white hover:text-gray-300 ml-1">Datenschutzerklärung</a>
        </div>
        <div class="flex gap-3">
          <button (click)="decline()" class="px-4 py-2 text-sm border border-gray-500 text-gray-200 rounded hover:bg-gray-800">
            Ablehnen
          </button>
          <button (click)="accept()" class="px-4 py-2 text-sm bg-brand-accent text-white rounded hover:opacity-90">
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  `
})
export class CookieConsentComponent {
  showBanner = false;
  privacyUrl = `${environment.apiUrl}/datenschutz.pdf`;

  constructor(private cookieConsentService: CookieConsentService) {
    this.showBanner = this.cookieConsentService.getConsent() === null;

    if (this.cookieConsentService.hasAnalyticsConsent()) {
      if (['localhost', '127.0.0.1'].includes(window.location.hostname)) {
        console.info('[Matomo] Consent already stored, initializing');
      }
      this.cookieConsentService.initMatomo();
    }
  }

  accept() {
    this.cookieConsentService.acceptAnalytics();
    this.showBanner = false;
  }

  decline() {
    this.cookieConsentService.declineAnalytics();
    this.showBanner = false;
  }
}
